export default __webpack_public_path__ + "static/media/accessory-simmer-plate-cover.32cc195a.png";